import { render, staticRenderFns } from "./google-address.vue?vue&type=template&id=b4fdc984&scoped=true"
import script from "./google-address.vue?vue&type=script&lang=js"
export * from "./google-address.vue?vue&type=script&lang=js"
import style0 from "./google-address.vue?vue&type=style&index=0&id=b4fdc984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fdc984",
  null
  
)

export default component.exports